import { __assign, __rest } from "tslib";
import React, { Fragment } from 'react';
import { asFormattedString } from '@at/formatter-utils/lib/number-utils/number.utils';
import { BodyType } from './body-type-selector.types';
import * as Styled from './body-type-selector.styled';
var getBodyTypeIcon = function (bodyType) {
    switch (bodyType) {
        case BodyType.convertible:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/convertible.png';
        case BodyType.coupe:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/coupe.png';
        case BodyType.estate:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/estate.png';
        case BodyType.hatchback:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/hatchback.png';
        case BodyType.mpv:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/mpv.png';
        case BodyType.pickup:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/pickup.png';
        case BodyType.saloon:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/saloon.png';
        case BodyType.suv:
            return 'https://m.atcdn.co.uk/static/media/body-type/s/suv.png';
        case BodyType.combiVan:
            return 'https://m.atcdn.co.uk/static/media/body-type/0dfbd913-5953-483d-a7ea-10d2e5b7446d-combi-van.png';
        case BodyType.minibus:
            return 'https://m.atcdn.co.uk/static/media/body-type/7fe2e7a7-a443-428a-b537-aa0c90d6b338-minivan.png';
        case BodyType.carDerivedVan:
            return 'https://m.atcdn.co.uk/static/media/body-type/c429af71-5395-4082-84dd-d5319331a2d6-car-derived-van.png';
        case BodyType.camper:
            return 'https://m.atcdn.co.uk/static/media/body-type/c7516c34-b168-4f27-9457-3d53829dc2e7-campervan.png';
        case BodyType.limousine:
            return 'https://m.atcdn.co.uk/static/media/body-type/29fa1806-e481-44d8-bc1d-61ee74dfaf58-limousine.png';
        case BodyType.panelVan:
            return 'https://m.atcdn.co.uk/static/media/body-type/7b445999-efc9-4f79-b15c-c60e795a0266-panel-van.png';
        case BodyType.hearse:
            return undefined;
        case BodyType.windowVan:
            return undefined;
        default:
            return '';
    }
};
var VerticalBodyTypeSelector = function (_a) {
    var className = _a.className, onChange = _a.onChange, name = _a.name, count = _a.count, selected = _a.selected, _b = _a.imageAlt, imageAlt = _b === void 0 ? '' : _b, layout = _a.layout, _c = _a.withIcon, withIcon = _c === void 0 ? true : _c;
    var isDisabled = !count;
    var hasCount = (count && count > 0) || false;
    return (React.createElement(Styled.BodyTypeSelectorItem, { className: className, "$isDisabled": isDisabled, "$layout": layout },
        React.createElement(Styled.BodyTypeSelector, { htmlFor: name },
            React.createElement(Styled.BodyTypeSelectorCheckbox, { "$isDisabled": isDisabled, "$layout": layout, "$isChecked": selected || false, className: "visuallyhidden", type: "checkbox", id: name, name: name, value: name, onChange: onChange, disabled: isDisabled, checked: selected || false }),
            React.createElement(Styled.BodyTypeSelectorLabel, { "$isChecked": selected || false, className: "atds-type-prius" },
                React.createElement(Styled.BodyTypeSelectorTick, { "$isChecked": selected || false, xmlns: "http://www.w3.org/2000/svg", width: "16", viewBox: "0 0 16 16" },
                    React.createElement("title", null, "tick"),
                    React.createElement("path", { d: "M16 3.27637L15.058 2.33337L5.333 12.0574L0.942 7.66737L0 8.60937L4.861 13.4704C4.982 13.5914 5.149 13.6674 5.333 13.6674C5.518 13.6674 5.685 13.5914 5.805 13.4704L16 3.27637Z" })),
                withIcon ? (getBodyTypeIcon(name) ? (React.createElement(Styled.BodyTypeSelectorIcon, { alt: imageAlt, src: getBodyTypeIcon(name) })) : (React.createElement(Styled.BodyTypeSelectorIconPlaceHolder, null))) : null,
                name,
                hasCount && (React.createElement(Fragment, null,
                    React.createElement("br", null),
                    "(",
                    asFormattedString(count || 0),
                    ")"))))));
};
var HorizontalBodyTypeSelector = function (_a) {
    var className = _a.className, onChange = _a.onChange, name = _a.name, count = _a.count, selected = _a.selected, _b = _a.imageAlt, imageAlt = _b === void 0 ? '' : _b, layout = _a.layout, _c = _a.withIcon, withIcon = _c === void 0 ? true : _c, otherHTMLProperties = __rest(_a, ["className", "onChange", "name", "count", "selected", "imageAlt", "layout", "withIcon"]);
    var isDisabled = !count;
    var hasCount = (count && count > 0) || false;
    return (React.createElement(Styled.BodyTypeSelectorItem, __assign({ className: className, "$isDisabled": isDisabled, "$layout": layout }, otherHTMLProperties),
        React.createElement(Styled.BodyTypeSelectorHorizontal, { "$isDisabled": isDisabled, "$isChecked": selected || false },
            React.createElement(Styled.StyledSelectionCheckbox, { fieldType: "checkbox", reverse: true, label: React.createElement(Styled.IconLabelCountContainer, null,
                    withIcon ? (getBodyTypeIcon(name) ? (React.createElement(Styled.Icon, { alt: imageAlt, src: getBodyTypeIcon(name) })) : (React.createElement(Styled.BodyTypeSelectorIconPlaceHolder, null))) : null,
                    React.createElement(Styled.Label, { as: "span", "$isDisabled": isDisabled, "$isChecked": selected || false }, name),
                    hasCount && count ? (React.createElement(Styled.CountLabel, { as: "span" }, count.toLocaleString())) : null), id: name, name: name, onChange: onChange, attributes: {
                    value: name,
                    disabled: isDisabled,
                    checked: selected || false,
                    'aria-labelledby': name,
                }, value: name, disabled: isDisabled, checked: selected || false, "aria-labelledby": name }))));
};
export var BodyTypeSelector = function (_a) {
    var onChange = _a.onChange, name = _a.name, count = _a.count, selected = _a.selected, url = _a.url, _b = _a.imageAlt, imageAlt = _b === void 0 ? '' : _b, _c = _a.layout, layout = _c === void 0 ? 'vertical' : _c, _d = _a.withIcon, withIcon = _d === void 0 ? true : _d, otherHTMLProperties = __rest(_a, ["onChange", "name", "count", "selected", "url", "imageAlt", "layout", "withIcon"]);
    var hasCount = (count && count > 0) || false;
    var props = {
        onChange: onChange,
        name: name,
        count: count,
        selected: selected,
        url: url,
        imageAlt: imageAlt,
        layout: layout,
        withIcon: withIcon,
    };
    var bodyTypeSelector = layout === 'vertical' ? (React.createElement(VerticalBodyTypeSelector, __assign({}, props, otherHTMLProperties))) : (React.createElement(HorizontalBodyTypeSelector, __assign({}, props, otherHTMLProperties)));
    var bodyTypeLink = (React.createElement(Styled.BodyTypeSelectorLink, __assign({}, otherHTMLProperties, { href: url }),
        React.createElement(Styled.BodyTypeSelectorLabel, { className: "atds-type-prius" },
            withIcon ? (getBodyTypeIcon(name) ? (React.createElement(Styled.BodyTypeSelectorIcon, { alt: imageAlt, src: getBodyTypeIcon(name) })) : (React.createElement(Styled.BodyTypeSelectorIconPlaceHolder, null))) : null,
            name,
            hasCount && (React.createElement(Fragment, null,
                React.createElement("br", null),
                "(",
                asFormattedString(count || 0),
                ")")))));
    if (url && url !== '') {
        return bodyTypeLink;
    }
    else {
        return bodyTypeSelector;
    }
};
